module.exports = __webpack_public_path__ + "img/CellCycle-BRCA_10X_IDC.1834bda8.png";